import React from 'react';
import { Label } from '@headlessui/react';

const SwitchLabel: React.FunctionComponent<{ label: string }> = ({ label }) => {
	return <Label className="flex flex-col cursor-pointer" ><p className="text-xs font-semibold text-gray-900">{label}</p></Label>;
};

export default SwitchLabel;